import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 路由表
        fullRoutes: [],
        // 用户信息
        cwUserInfo: {},
        domain: ''
    },
    mutations: {
        // 清除路由表
        clearRoutes (state) {
            state.domain = []
        },
        SET_DOMAIN(domain) {
            state.domain = domain
        },
        // 连接路由表
        concatRoutes (state, payload) {
            state.fullRoutes = state.fullRoutes.concat(payload)
        },
        // 更新用户信息
        updateCwUserInfo (state, payload) {
            state.cwUserInfo = payload
        },
        // 清除用户信息
        clearCwUserInfo (state) {
            state.cwUserInfo = {}
        },
    },
    getters: {

    },
    // 所有异步操作
    actions: {

    },
    modules: {

    }
})



// WEBPACK FOOTER //
// ./src/page/cw/store/index.js